import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Menu  {
    _originalTypeClassName = "ekylikeio.BO.Menu";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Menu.translate = translateService;
}
this.menuToMenuItem = [];
this.Id = null;
this.Name = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
menuToMenuItem:any;
static setmenuToMenuItem = ($this, items) => {
                if (items == null) items = [];
                if ($this.menuToMenuItem == null) $this.menuToMenuItem = [];

                const copyItems = Common.cloneObject(items);

                while ($this.menuToMenuItem.length > 0) {
                    Domain.Menu.removemenuToMenuItem($this, $this.menuToMenuItem[0]);
                }

                Domain.Menu.addManymenuToMenuItem($this, copyItems);
            }
static addManymenuToMenuItem = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Menu.addmenuToMenuItem($this, items[i]);
                }
            }
static addmenuToMenuItem = ($this, item) => {
                if ($this.menuToMenuItem == null) $this.menuToMenuItem = [];
                if (item == null || $this.menuToMenuItem.indexOf(item) > -1) return;
                $this.menuToMenuItem.push(item);
}
static addRangemenuToMenuItem = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Menu.addmenuToMenuItem($this, item));
            }
static removemenuToMenuItem = ($this, item) => {
                if ($this == null || $this.menuToMenuItem == null || $this.menuToMenuItem.indexOf(item) === -1) return;
                var _index = $this.menuToMenuItem.indexOf(item);
                $this.menuToMenuItem.splice(_index, 1);
}
static clearmenuToMenuItem = ($this) => { $this.menuToMenuItem = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}